import { motion } from "framer-motion";
import { MicroLabel } from "@/components/decor/CropMarks";

const STAGES = [
  { n: "01", t: "Understand", d: "Brief, audience, channels, scale, and brand context — captured as a production brief." },
  { n: "02", t: "Plan", d: "Specifications, materials, finishes, quantities, timelines, and delivery plan." },
  { n: "03", t: "Design Support", d: "Identity application, print-ready files, packaging direction, and visual continuity." },
  { n: "04", t: "Material Selection", d: "Paper stock, surface, foil, vinyl, acrylic, fabric — chosen for purpose and longevity." },
  { n: "05", t: "Produce", d: "Pre-press, printing, fabrication, and quality checks before any item leaves the floor." },
  { n: "06", t: "Finish", d: "Lamination, foil, emboss, spot UV, die-cut, finishing details that elevate the artifact." },
  { n: "07", t: "Deliver", d: "Pack, ship, install, place — handled with the same precision as printing." },
  { n: "08", t: "Support", d: "Reorders, refreshes, future runs and long-term system maintenance." },
];

const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative"
      style={{ background: "#0A0A0A", paddingTop: 120, paddingBottom: 120 }}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 lg:px-12">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
          <div>
            <MicroLabel index={8} accent="#B89B5E">
              Process
            </MicroLabel>
            <h2
              className="mt-6"
              style={{
                fontFamily: "Montserrat",
                fontWeight: 800,
                color: "#F5F1E8",
                fontSize: "clamp(34px, 5vw, 64px)",
                lineHeight: 0.98,
                letterSpacing: "-0.025em",
                textTransform: "uppercase",
              }}
            >
              Eight stages.
              <br />
              <span style={{ color: "#B89B5E" }}>One assembly line.</span>
            </h2>
          </div>
          <p
            style={{
              color: "#C0C0C0",
              maxWidth: 420,
              fontSize: 14,
              lineHeight: 1.7,
            }}
          >
            Krister Overseas runs every project as a system. Each stage hands the
            next a clear input — like plates on a printing press.
          </p>
        </div>

        <div className="relative">
          {/* vertical registration track */}
          <div
            aria-hidden
            className="hidden md:block absolute top-0 bottom-0"
            style={{
              left: 18,
              width: 1,
              background:
                "linear-gradient(to bottom, rgba(184,155,94,0.0), rgba(184,155,94,0.6), rgba(184,155,94,0.0))",
            }}
          />

          <ol className="space-y-px">
            {STAGES.map((s, i) => (
              <motion.li
                key={s.n}
                data-testid={`process-stage-${s.n}`}
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.55, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
                className="relative grid grid-cols-12 gap-4 md:gap-8 py-7 md:py-8"
                style={{ borderTop: "1px solid rgba(192,192,192,0.12)" }}
              >
                {/* node */}
                <div className="col-span-12 md:col-span-1 flex md:block items-center gap-3">
                  <div
                    className="relative flex items-center justify-center"
                    style={{
                      width: 38,
                      height: 38,
                      border: "1px solid #B89B5E",
                      background: "#0A0A0A",
                    }}
                  >
                    <span
                      className="ko-overline"
                      style={{ color: "#B89B5E", fontSize: 10 }}
                    >
                      {s.n}
                    </span>
                  </div>
                </div>
                <div className="col-span-12 md:col-span-4">
                  <h3
                    style={{
                      fontFamily: "Montserrat",
                      fontWeight: 700,
                      color: "#F5F1E8",
                      fontSize: "clamp(22px, 2.2vw, 32px)",
                      letterSpacing: "-0.015em",
                      textTransform: "uppercase",
                    }}
                  >
                    {s.t}
                  </h3>
                </div>
                <div className="col-span-12 md:col-span-7">
                  <p
                    style={{
                      color: "#C0C0C0",
                      fontSize: 15,
                      lineHeight: 1.75,
                    }}
                  >
                    {s.d}
                  </p>
                </div>
              </motion.li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default Process;
